import type { TopupQueueRow } from "@/modules/wallet/domain/types";

/** Counter top-up completed on POS via customer QR (auto-approved). */
export function isPosQrCounterTopup(row: TopupQueueRow): boolean {
  return row.method === "CASHIER" && Boolean(row.sourceSessionId?.trim());
}

export function formatTopupMethodLabel(row: TopupQueueRow): string {
  if (isPosQrCounterTopup(row)) {
    return "ເຄົ້າເຕີ POS (QR)";
  }
  if (row.method === "CASHIER") {
    return "ເງິນສົດ (ເຄົ້າເຕີ)";
  }
  return "ໂອນເງິນ (Slip)";
}

export function topupNeedsAdminApproval(row: TopupQueueRow): boolean {
  return row.status === "PENDING" && !isPosQrCounterTopup(row);
}
